import script from "./PaginationPart.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationPart.vue?vue&type=script&setup=true&lang=js"

import "./PaginationPart.vue?vue&type=style&index=0&id=cce6b43c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cce6b43c"]])

export default __exports__